<template>
  <div id="schedule">
    <v-btn class="action" color="primary" :disabled="loading" @click="save">
      Save
    </v-btn>
    <v-btn class="action" color="grey" dark @click="refresh">Refresh</v-btn>
    <v-btn class="action" color="green darken-2" dark to="/schedule-basic"
      >Basic</v-btn
    >
    <v-container v-if="!loading" fluid>
      <v-tabs v-model="tab">
        <v-tab v-for="b of this.bots" :key="b.name"> {{ b.name }}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="(b, i) of this.bots" :key="b.name" :value="i">
          <v-card flat>
            <prism-editor
              class="my-editor"
              v-model="b.schedule"
              language="json"
              :highlight="highlighter"
            ></prism-editor>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
    <v-container fill-height fluid class="load-parent">
      <v-progress-circular
        v-if="loading"
        indeterminate
        color="primary"
        class="loader"
      ></v-progress-circular>
    </v-container>
  </div>
</template>

<script>
import { PrismEditor } from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css";

import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-json";
import "prismjs/themes/prism-coy.css";

import { get, saveSchedule } from "../lib/bots";

export default {
  name: "ScheduleAdvanced",
  components: {
    PrismEditor
  },
  data() {
    return {
      loading: true,
      tab: null,
      bots: []
    };
  },
  methods: {
    highlighter(code) {
      return highlight(code, languages.json);
    },
    async save() {
      try {
        this.loading = true;
        const b = this.bots[this.tab];
        const schedule = JSON.parse(b.schedule);
        await saveSchedule(b.name, schedule);
        this.loading = false;
      } catch (err) {
        this.showError(`Unable to save schedule - ${err}`);
      }
    },
    async refresh() {
      try {
        this.loading = true;
        const resp = await get();
        this.bots = resp
          .filter(b => b.active)
          .map(b => {
            const s = {
              DefaultTimes: b.schedule.DefaultTimes,
              AutomatedTimes: b.schedule.AutomatedTimes,
              ManualOverrides: b.schedule.ManualOverrides
            };

            return {
              name: b.sort,
              schedule: JSON.stringify(s, null, 2)
            };
          });
        this.loading = false;
      } catch (err) {
        this.showError(`Unable to read schedule - ${err}`);
      }
    }
  },
  async mounted() {
    this.refresh();
  }
};
</script>

<style lang="scss">
#schedule {
  .load-parent {
    min-height: 300px;
    width: 100%;

    .loader {
      margin: auto;
    }
  }
}
</style>
